var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('audio',{ref:"player",attrs:{"autoplay":"","loop":""}},[_c('source',{attrs:{"src":_vm.audioSource,"type":"audio/mp3"}})])])}
var staticRenderFns = []

export { render, staticRenderFns }